<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerMerchandisers">
        <template #header>
          <ProSpaceAction :text="$t('editItemTxt')" @click="editPanel" />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { MerchandiserService } from "../../../services/MerchandiserService";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "MerchandiserPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    checkAccess: {
      type: Function,
    }
  },
  data() {
    return {
      merchandiser: null,
      merchandiserService: new MerchandiserService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime"
    }),
    headerMerchandisers() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.merchandiser) {
        return {
          title: this.merchandiser.value,
          id: this.ids[0],
          status: this.getStatus(this.merchandiser.status),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      let content = [];
      if (this.merchandiser) {
        content.push([{ title: this.$t("merchandiserValue"), text: this.merchandiser.value }]);
        if (this.checkAccess && this.checkAccess("agencyValue-rightPanel"))
            content.push([{ title: this.$t("merchandiserAgencyValue"), text: this.merchandiser.agencyValue }]);
      }
      return content;
    },
    contentBottom() {
      if (this.merchandiser) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.merchandiser.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.merchandiser.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.merchandiser.createdAt) + ' ' + getAMorPM(this.merchandiser.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.merchandiser.lastUpdated) + ' ' + getAMorPM(this.merchandiser.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    update() {
      this.hasError = false;
      try {
        this.getMerchandiser();
      } catch (e) {
        this.hasError = true;
      }
    },
    getMerchandiser() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.merchandiserService.get(this.ids[0]).then((res) => {
          this.merchandiser = res.data;
          this.loading = false;
        });
      }
      this.merchandiser = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.merchandiser);
    },
    deletePanel() {
      this.$emit("delete", this.merchandiser);
    },
    showHistoryPanel() {
      this.$emit("history", this.merchandiser);
    },
  },
};
</script>

<style scoped></style>
